import { useEffect, useRef, useState } from "react";
import "./index.css";
import ChatWindow from "../ChatWindow/ChatWindow";
import ChatUserIcon from "../ChatUserIcon";
import ChatActions from "../ChatActions";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import socketIOClient from "socket.io-client";
import {
  handleInitChatWindow,
  closeChatWindow,
  handleHideChatWindow,
  fetchRoomIds,
  setInitRoomsNotification,
  getAllNotification,
  resetData,
  handleUnHideChatWindow,
  closeChatIcon,
  handleCloseAllChat,
  handleHideAllChat,
} from "../../../../redux/actions/notLoginEndUserChatActions";

const Chat = (props) => {
  const dispatch = useDispatch();
  const { chatWindows, chatIcons, roomsNoti, roomsInitNoti, roomIdList } =
    useSelector(
      ({ notLoginEndUserChat }) => ({
        chatWindows: notLoginEndUserChat.chatWindows,
        chatIcons: notLoginEndUserChat.chatIcons,
        roomIdList: notLoginEndUserChat.roomIdList,
        roomsNoti: notLoginEndUserChat.roomsNoti,
        roomsInitNoti: notLoginEndUserChat.roomsInitNoti,
      }),
      shallowEqual,
    );
  const socketRef = useRef();

  useEffect(() => {
    socketRef.current = socketIOClient.connect(
      `${process.env.REACT_APP_API_URL}/end-user-no-login-chat`,
    );
    // clean up
    return () => {
      socketRef.current.disconnect();
    };
  }, []);

  // useEffect(() => {
  //   dispatch(
  //     fetchRoomIds(token, user.id)
  //   )
  // }, [user.id])

  useEffect(() => {
    socketRef.current?.on("Server-send-all-user", (resp) => {
      const chatSession = JSON.parse(
        localStorage.getItem("reeco-chat-session"),
      );
      if (chatSession?.token) {
        dispatch(handleInitChatWindow());
      }
    });
  }, []);

  // useEffect(() => {
  //   dispatch(getAllNotification(user.id))
  // }, [user.id])

  useEffect(() => {
    return () => {
      dispatch(resetData());
    };
  }, []);

  const closeWindow = (id) => {
    dispatch(closeChatWindow(id));
  };

  const closeIcons = (id) => {
    dispatch(closeChatIcon(id));
  };

  const handleInitChat = async () => {
    if (chatWindows?.length > 0 || chatIcons?.length > 0) return;
    dispatch(handleInitChatWindow());
  };

  const handleHideChat = (id, messageList) => {
    dispatch(handleHideChatWindow(id, messageList));
  };

  const handleUnHide = (id, messageList, roomNoti) => {
    dispatch(handleUnHideChatWindow(id, messageList, roomNoti));
  };

  const handleCloseAll = () => {
    dispatch(handleCloseAllChat());
  };

  const handleHideAll = () => {
    dispatch(handleHideAllChat());
  };

  return null;

  return (
    <div className="chat-box">
      <div className="chat-icon" onClick={handleInitChat}>
        <img src="/images/chat-icon.png" />
        {(chatWindows.filter((item) => item.status !== "new").length > 0 ||
          chatIcons.length > 0) && (
          <ChatActions onHideAll={handleHideAll} onCloseAll={handleCloseAll} />
        )}
        {(roomsInitNoti?.length > 0 || roomsNoti?.length > 0) && (
          <div className="all-noti"></div>
        )}
      </div>
      <div className="chat-windows">
        {chatWindows?.map((item) => (
          <ChatWindow
            key={item.id}
            item={item}
            onClose={closeWindow}
            onHide={handleHideChat}
            handleInitChat={handleInitChat}
            socket={socketRef.current}
          />
        ))}
      </div>
      <div className="chat-user-icons">
        {chatIcons?.map((item) => (
          <ChatUserIcon
            key={item.id}
            item={item}
            onUnHide={handleUnHide}
            onClose={closeIcons}
            socket={socketRef.current}
            roomNoti={roomsNoti.find(
              (elm) => elm.roomChatId === item.roomChatId,
            )}
          />
        ))}
      </div>
    </div>
  );
};

export default Chat;
